// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".min--height__content--view--cp {\n  min-height: 64vh;\n}", ""]);
// Exports
module.exports = exports;
